export default {
      id: "heart-usage",
      viewBox: "0 0 393.977 363.422",
      url: __webpack_public_path__ + "sprite.svg#heart",
      toString: function () {
        return this.url;
      }
    }